<template>
  <div class="home">
    <div class="header" :style="{ paddingRight: headerPaddingRight }">
      <!-- 0 calc((100% - 1100px)/2) 0 calc((100% - 1140px)/2) -->
      <div class="header_help header_item" @click="toGuide">
        <!-- <img class="icon" src="../assets/problem.png" alt=""> -->
        <i class="el-icon-document"></i>
        <span>{{$t('guide')}}</span>
      </div>
      <div class="header_help header_item" @click="toProblem">
        <img class="icon" src="../assets/problem.png" alt="">
        <span>{{$t('problem')}}</span>
      </div>
      <div class="header_help header_item" @click="toHelp">
        <img class="icon" src="../assets/help.png" alt="">
        <span>{{$t('help')}}</span>
      </div>
      <div class="header_locale header_item">
        <div class="lang-btn" @click="isShowChangeLocale = true">
          <img class="icon" src="../assets/icon-lan2.png" alt="">
          <span>{{ $t('locale') }}</span>
          <img class="icon icon_down" src="../assets/down-row.png" alt="">
        </div>

        <localeChangeVue @closeBox="closeBox" @localeChange="localeChange" v-show="isShowChangeLocale"></localeChangeVue>
      </div>
    </div>
    <div class="content">
      <!-- mx模块 -->
      <div class="content_item">
        <div class="mx">
          <div class="content_herder">
            <img class="content_herder_img-zh" v-if="locale !== 'en-US'" src="../assets/mx-title.png" alt="">
            <img class="content_herder_img-en" v-else src="../assets/mx-title-en.png" alt="">
          </div>
          <div class="content_center">
            <div class="content_introduce">
              {{ $t('mx.introduce') }}
            </div>
            <div class="content_tips">
              <div class="content_tips_top">
                {{ $t('mx.downTips') }}
              </div>
              {{ $t('codeLargeTip') }}
            </div>
          </div>
          <div class="mxDownloadList">
            <mxDownload ref="mxDownloadRef" :closeAllLargeBox="vpnCloseall"></mxDownload>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <!-- vpn模块 -->
      <div class="content_item">
        <div class="vpn">
          <div class="content_herder">
            <img class="content_herder_img" src="../assets/vpn-title.png" alt="" />
            <span>{{ $t('vpn.title') }}</span>
          </div>
          <div class="content_center">
            <div class="content_introduce">
              {{ $t('vpn.introduce') }}
            </div>
            <div class="content_tips">
              <div class="content_tips_top">
                {{ $t('vpn.downTips') }}
              </div>
              {{ $t('codeLargeTip') }}
            </div>
          </div>
          <div class="mxDownloadList">
            <vpnDownload ref="vpnDownloadRef" :closeAllLargeBox="mxCloseall"></vpnDownload>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      Copyright © 1968-{{curYear}} Midea Group
    </div>
  </div>
</template>
<script>
import localeChangeVue from "@/components/localeChange";
import mxDownload from "@/components/mxDownload";
import vpnDownload from "@/components/vpnDownload";
import { getApiConfig } from '@/mx-service/libs/http/config'
// import localeChange from "@/components/localeChange";

export default {
  components: {
    localeChangeVue,
    mxDownload,
    vpnDownload
  },
  data() {
    return {
      isShowChangeLocale: false,
      locale: 'zh-CN',
      headerPaddingRight: '124px',
      curYear: new Date().getFullYear()
    };
  },
  methods: {
    closeBox(){
      this.isShowChangeLocale = false
    },
    toGuide() {
      if (this.locale === 'zh-CN') {
        window.open(getApiConfig()._guideZh, '_blank')
      } else {
        window.open(getApiConfig()._guideEn, '_blank')
      }
    },
    toHelp(){
      window.open(getApiConfig()._feedback, '_blank')
    },
    toProblem(){
      window.open(getApiConfig()[`${this.$t('toProblem')}`], '_blank')
    },
    vpnCloseall(){
      this.$refs.vpnDownloadRef.smallImg();
    },
    mxCloseall(){
      this.$refs.mxDownloadRef.smallImg();
    },
    localeChange(e){
      this.locale = e
    }
  },
  mounted(){
    const _locale = localStorage.getItem('locale')
    this.locale = _locale || 'zh-CN'
    const dom = document.getElementById('targetDom')
    if (dom) {
      try {
        const that = this
        this.headerPaddingRight = `calc(100% - ${dom.getBoundingClientRect().right}px - 7px)`
        window.addEventListener('resize', function () {
          that.headerPaddingRight = `calc(100% - ${dom.getBoundingClientRect().right}px - 7px)`
        })
      } catch (error) {
        console.error('设置头部padding失败：', error)
      }
    }
  }
};
</script>
<style lang="less" scoped>
.home {
  // width: 100%;
  min-width: 1240px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(180deg, #B8DCFF 0%, #EEF2FF 49%, #FFFFFF 100%) no-repeat;

  .header {
    width: 100%;
    padding-top: 29px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    // padding-right: 124px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    color: #333333;
    line-height: 17px;

    .header_item {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      .icon {
        width: 17px;
        height: 17px;
        margin-right: 7px;
      }
      .icon_down {
        width: 12px;
        height: 12px;
        margin-left: 7px;
      }

      .lang-btn {
        display: flex;
        align-items: center;
      }
    }
    .header_help {
      margin-right: 34px;
    }
    .el-icon-document {
      font-size: 17px;
      margin-right: 7px;
      color: #5f636f;
    }
  }

  .content {
    display: flex;
    // justify-content: space-around;
    align-items: center;
    width: 100%;
    height: calc(100% - 87px);
    // padding-top: 105px;
    // padding-top: 75px;
    .content_item {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(50% - 1px);
      box-sizing: border-box;
    }
    .line {
      width: 0;
      height: 241px;
      border-left: 1px solid #DDDDDD;
    }

    .mx {
      width: 100%;
      .content_herder_img-zh {
        width: 108px;
        height: 36px;
      }
      .content_herder_img-en {
        // width: 108px;
        height: 36px;
      }
      .content_introduce {
        height: 63px;
        font-size: 12px;
        color: #333333;
        line-height: 21px;
        width: 100%;
        padding: 0 73px 0 73px;
        box-sizing: border-box;
      }
      .content_tips {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        .content_tips_top {
          margin-bottom: 6px;
        }
      }
    }
    .vpn {
      .content_herder {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 19px;
        font-family: MEIDITYPE-BOLD, MEIDITYPE, sans-serif;
        font-weight: bold;
        color: #333333;
        line-height: 38px;

        .content_herder_img {
          width: 36px;
          height: 36px;
          margin-right: 9px;
        }
      }
      .content_introduce {
        height: 63px;
        font-size: 12px;
        color: #333333;
        line-height: 21px;
        width: 100%;
        padding: 0 85px 0 59px;
        box-sizing: border-box;
      }
      .content_tips {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
        .content_tips_top {
          margin-bottom: 6px;
        }
      }
    }
    .mx .content_center, .vpn .content_center {
      height: 120px;
      padding: 29px 0 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }

  .footer {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}
</style>
